import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';
import { NbButtonModule } from '@nebular/theme';

@NgModule({
  declarations: [ServiceUnavailableComponent],
  imports: [CommonModule, NbButtonModule],
  exports: [ServiceUnavailableComponent],
})
export class ErrorsModule {}
